import React from 'react';
import Form from './Custom/Form';
import Preview from './Custom/Preview';
import Grid from '@material-ui/core/Grid';

export default class Custom extends React.Component {


  render() {
    return (
      <div id="custom">
        <Grid  container direction="row">
            <Grid item xs={8}>
                <Form type={this.props.type} />
            </Grid>
            <Grid item xs={4}>
                <Preview type={this.props.type} />
            </Grid>
        </Grid>
      </div>
    )
  }
  
}



// WEBPACK FOOTER //
// ./src/Manager/Custom.js